import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex flex-col',
    backButton:
      'font-regular mb-[24px] flex flex-row items-center gap-[8px] text-xs text-white',
    backIcon: 'size-[24px] rotate-90 [&>path]:stroke-white',
    group: 'bg-bg-page mt-5 py-6 md:px-4'
  },
  variants: {
    color: {
      primary: 'text-main'
    }
  },
  defaultVariants: {
    color: 'primary'
  }
});
